import React from "react";
import MainLogo from "../../assets/images/iAugment-logo-color.png";
import { useAuthPage } from "../../customHooks/AuthPage/useAuthPage";
import "./AuthPage.css";
import "./login.css";
import { Loader } from "react-feather";

export default function AuthPage() {
  const hookProps = useAuthPage();
  const { setUsername, setPassword, handleSubmit, errors, loading } = hookProps;

  return (
    <div className="Darkbg">
      <div className="FirstGackground">
        <div className="MainLogoTop">
          <img src={MainLogo} alt="Logo" />
        </div>
        <div className="position-relative MobileView">
          <div className="col-lg-5 col-md-6 col-10 log">
            <div className="LoginHeader">
              <h2>Login</h2>
              <small>Continue to Login with Email and Password!</small>
            </div>
            <div className="mt-5">
              <div className="FormText">
                <form onSubmit={handleSubmit}>
                  <div className="input-cont">
                    <input
                      type="text"
                      className="FormControl"
                      onChange={(e) => setUsername(e.target.value)}
                    />
                    <label>Email address</label>
                    <div className="border1"></div>
                    {errors.username && (
                      <small className="error-message">{errors.username}</small>
                    )}
                  </div>

                  <div className="input-cont">
                    <input
                      className="FormControl"
                      type="password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <label>Enter Password</label>
                    <div className="border2"></div>
                    {errors.password && (
                      <small className="error-message">{errors.password}</small>
                    )}
                  </div>
                  <div>
                    <button
                      className="SignInButton"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? <Loader className="loader-icon" /> : "Sign In"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="RightImg"></div>
        </div>
      </div>
    </div>
  );
}
